import styled from 'styled-components';

import { colors } from '../../../constants';

export const LinkButton = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    max-width: 280px;
    height: 48px;
    padding: 0 30px;
    background-color: ${colors.orange};
    color: ${colors.white};
    border-radius: 5px;
    font-size: 16px;
    line-height: 1.4;
    transition: all 0.1s linear;

    // Overriding surrounding PNL hover styles
    :hover {
        text-decoration: none;
        color: ${colors.white};
        background-color: ${colors.orangeHover};
    }
`;
